export default {
    app_bar: {
        title: 'Admission Registration System for Undergraduate',
        title_graduate: 'Admission Registration System for Graduate',
        university_name: "King Mongkut's Institute of Technology Ladkrabang",
        user: 'user',
    },
    footer: {
        registrar: 'KMITL Registration and Educational Service Office',
        address1: '1 Soi Chalong Krung 1',
        address2: 'Ladkrabang Subdistrict, Ladkrabang District,',
        address3: 'Bangkok 10520',
        contact_undergraduate: 'Contact : Undergraduate',
        contact_graduate: 'Contact : Graduate',
        ext: "ext.",
    },
    login: {
        login: 'Login',
        register: 'Register',
        forgot_password: 'Reset Password',
        email: 'E-mail',
        password: 'Password',
        forgot_password_label: 'Citizen ID',
        forgot_password_hint: 'For foreigner, please fill in passport number',
        spam_mail_notice: "*If you do not receive the email, please check your Junk/Spam Mail.",
        officer_authen: "Login for Staff / Teacher",
    },
    create_password: {
        title: 'Create Password / Reset Password',
        link_cannot_use: 'The link cannot be used. Please use the most recently link.',
        set_password: 'Create Password',
        complete: 'Password created successfully.',
    },
    menu: {
        login: 'Login / Register',
        userID: 'Citizen ID / Passport ID / Email',
        explore: 'Curriculum Search',
        explore_undergraduate: 'Curriculum Search | Undergraduate',
        explore_master: 'Curriculum Search | Master',
        explore_phd: 'Curriculum Search | Ph.D',
        explore_graduate: 'Curriculum Search | Graduate',
        announcement_undergraduate: 'Announcement | Undergraduate',
        announcement_graduate: 'Announcement | Graduate',
        create_user: 'Create User Account',
        logout: 'Logout',
        registered_program_list: 'Registered List',
        applicant_info: 'Applicant Infomation',
        config_year: 'Specify the academic year',
        config_faculty_bank_account: 'Specify the faculty bank account',
        config_round: 'Specify the application round',
        config_project: 'Specify the project',
        config_project_group: 'Specify the project Group',
        config_project_group_name_en: 'Project group name(English)',
        config_project_group_name_th: 'Project group name(Thai)',
        config_curriculum: 'Specify the curriculum',
        config_curriculum_constraint: 'Specify the curriculum conditions',
        config_master_reg_curriculum: 'Specify the curriculum TCAS ID/Inter',
        application_documents_guide: 'Application Documents Guide',
        config_faculty_officer_main: 'Config Faculty User right',
        manual_admission_for_executor_level_1: 'คู่มือกำหนดผู้ผ่านการคัดเลือก',
        manual_admission_for_executor_level_2: 'คู่มือยืนยันผู้ผ่านการคัดเลือก',
        config_curriculum_gat_pat: 'Specify the percentage GAT/PAT',
        move_applicant: 'Edit Applicant Info',
        gen_student_id_and_import_to_maticulation_system: 'Gen student ID and import to maticulation system',
        gen_student_id: 'Gen Student ID',
        gen_student_id_graduate: 'Gen Student ID 4+1',
        move_to_marticulation_online: 'Import applicant to maticulation system',
        search_user: 'ค้นหา / แก้ไข ข้อมูลผู้สมัคร',

        save: "Save",

        applicant_info_general: 'Applicant Info',
        applicant_info_school: 'School Info',
        applicant_info_university: 'University Info',
        applicant_info_medicine: 'Faculty of Medicine Info',
        applicant_info_eng_inter: 'International Program Info',
        applicant_info_constraints: 'Required info for application',
        applicant_info_add: 'ข้อมูลเพิ่มเติม',

        questionnaire: 'Questionnaire',

        number_of_applicants_report: "Reports",
        number_of_applicants_by_order_report: "Reports by Order + Selective",
        number_of_applicants_passed_report: "Reports by Passed",
        not_paid_tuition_fee: "รายงานค้างค่าธรรมเนียมการศึกษา",
    },
    explore: {
        undergraduate: 'Undergraduate',
        graduate: 'Graduate',
        admission_system_undergraduate: 'Undergraduate Admission System',
        admission_system_master: 'Master Admission System',
        admission_system_phd: 'Ph.D Admission System',
        admission_system_graduate: 'Graduate Admission System',
        find_open_curriculum: 'Search Open Curriculum',
        select_faculty_to_search: 'Search Faculty / College / Campus',
        select_round_to_search: 'Search Round',
        round: 'Round',
        faculty_of: 'Faculty of ',
        more_search_words: 'Additional search (Enter to separate words) [The system will search by faculty name and Curriculum name]',
        select_project_to_search: 'Search Project',
        select_inter_to_search: 'Search Inter / Thai Curriculum',
        popup_dialog_title: 'Notification',
        popup_dialog_text: 'Faculties may be open to receiving Portfolio in rounds 1-1 to 1-4, Please follow more details of receiving Portfolio in rounds 1-1 to 1-4.',
    },
    program_list: {
        search_results: 'About',
        curriculum: 'Curriculum',
        list: 'results',
        round: 'Round:',
        project: 'Project:',
        open_date: 'Application Open Date',
        branch: 'Branch',
        register: 'Apply',
        remark: "Remark",
        reason_to_cancel: 'reason to cancel',
        announcement: 'Announcement',
        additional_info: 'Additional Info',
        additional_info_graduate: 'Qualification of applicant',
        study_admit_type: 'Admit type',
        study_plan: 'Plan',
        study_classes: 'Class',
        specific_nation: 'Only',
        no_result: 'no result',
    },
    announcement: {
        announcement_main: 'Main Page Announcement',
        announcement: 'News/Announcement/PR',
        announcement_tcas: 'TCAS Announcement',
        announcement_inter: "International Program Announcement",
        announcement_con: "Continuing Program Announcement",
        announcement_premium: "Hight Vocational Premium Program Announcement",
        announcement_special: "Special Round",

        application_announcement: 'Application Announcement',
        writing_information: 'Permission of Writing Exam/Practical Exam',
        interview_information: 'Permission to take an interview',
        clearing_house: 'Clearing House',
        qualified: 'Permission to Study',
        matriculation: 'KMITL Matriculation',
        title: 'Title',
        detail: 'Detail',
        swift: 'Swift >> for additional information'
    },
    announcement_graduate: {
        announcement_main: 'Main Page Announcement',
        announcement: 'News/Announcement/PR',
        announcement_pdf_file: 'Download PDF files',
        announcement_master: 'Master Degree Programs Announcement',
        announcement_inter: "International Programs Announcement",
        announcement_doctor: "Doctor Degree Programs Announcement",
        announcement_future_innovators: "Future Innovators Programs Announcement",

        application_announcement: 'Application Announcement',
        writing_information: 'Permission of Writing Exam/Practical Exam',
        interview_information: 'Permission to take an interview',
        qualified: 'Get the right to study',
        confirm_pay: 'Assertion',
        title: 'Title',
        detail: 'Detail',
    },
    registered_program_list: {
        title: 'Registered List',
        announcement: 'Application announcement / Announcement of applicants who are eligible for the examination / Other announcements',
        round: 'Round',
        open_date: 'Application Open Date',
        registration_no: 'Registration No.',
        application_document: 'Application',
        faculty: 'Faculty',
        curriculum: 'Curriculum',
        branch: 'Branch',
        no: 'No.',
        close: 'Close',
        academic_year: 'Academic Year',
        project_application: 'Project Application',
        curriculum_to_apply: 'Curriculum to apply',
        not_completed_all_information: 'You have not completed all information.',
        completed_the_application: 'You have completed the application.',
        print_pay_in_process: 'Print out pay-in slip/ In the process of payment.',
        verify_within_3_days: '*If you already paid, the system will verify within 3 official days. (After the period expires, but the payment status has not changed, please contact officer within 1 day to verify.)',
        payment_can_be_made_since: 'Payment can be made from',
        to: 'to',
        print_pay_in_slip: 'Print pay-in slip',
        application_paid: 'The application fee has been paid.',
        did_not_make_payment_in_time: 'You did not make the payment in specific time.',
        announcement_selection_result: 'Admission Results',
        result_has_not_been_announced: 'The result has not been announced.',
        result_announced: 'Announcement on the menu → ',
        result_announced_1: 'Announcement | Undergraduate',
        result_announced_2: 'Announcement | Graduate',
        according_announced: ', according to the specified date.',
        pass: 'Pass',
        not_pass: 'Not pass',
        announcement_CH_result: 'Announcement of Clearing House result.',
        select: 'Select',
        not_select: 'Not select',
        print_payment_slip_assertion_in_process_assertion: 'Print the payment slip for assertion./In the process of assertion.',
        already_assertion: 'You already assertion.',
        cancel_application: 'Cancel an application',
        canceled_application_list: 'Canceled an application list.',
        canceled_project_application: '(Canceled) Project Application',
        canceled_from_date: 'Canceled from the date',
        reason_for_cancellation: 'The reason for the cancellation',
        cancellation_application_no: 'Cancellation of application no.',
        cancel_this_application_if_you_have_paid_application_fee: 'Cancel this application, If you have paid the application fee.',
        system_not_refund_application_fee_students: 'The system will not refund the application fee to students.',
        if_student_would_like_cancel_application: 'If a student would like to cancel the application.',
        please_fill_reason_for_cancellation_box_below: 'Please fill in the reason for cancellation in the box below.',
        confirm_cancel_application: 'Confirm cancellation an application.',
        print_payin_slip_kbank: 'Print Pay in Slip (Kasikorn Bank)',
        print_payin_slip_scb: 'Print Pay in Slip (SCB)',
        additional_documents: 'Additional documents (if any)',
    },
    project_file_upload: {
        upload_only_specify: 'Upload supporting documents/application documents (according to the announcement, only for the specified curriculum)',
        file_size: 'Applicants can upload 1 application document as a PDF file with a size not exceeding 4 MB',
        detail: '(If there is more than 1 uploaded document, applicants must submit the PDF file as a single file.)',
        upload_file: 'Upload File',
        uploaded_file: 'Uploaded File',
        no_file_uploaded: 'No File Uploaded',
        view: 'View',
        delete: 'Delete',
        confirm_delete_file: 'Confirm to delete the file',
        upload: 'Upload',
    },
    confirm_regis: {
        confirm_regis: 'Confirm Application',
        project: 'Project',
        round: 'Round',
        academic_year: 'Academic Year',
        alert: 'You have already applied for this project. If you would like to re-apply, you need to cancel the original project. You can cancel at the page',
        registered_program_list: 'Registered List',
        fill_in_all_fields: 'Please complete the selection of curriculums  below.',
        no: 'No.',
        icon_remark1: 'Hot course can select only one.',
        icon_remark2: ' Study at KMITL Prince of Chumphon Campus, Chumphon Province.',
        remark: 'Remark',
        remark_payment_kmitl: 'In case of changing the course of study or changing the rank or changing the project that applied, students must apply again and have to pay for new application fee again only. The institute will consider the last application that the application fee has been paid is the time that you would like to take the exam.  Moreover, the previous apply will be void.  Even if the application fee has been paid.',
        remark_payment_ch_1: '1. Applicants who have passed the exam in the program of KMITL Prince of Chumphon Campus, in Chumphon Province. Students have to accept to study at KMITL Prince Chumphon Campus, in Chumphon Province, throughout the study from 1st Year to Year 4th .',
        remark_payment_ch_2: '2. The selection results are the deciding on the right of KMITL Prince of Chumphon, King Mongkut\'s Institute of Technology Ladkrabang.',
        remark_payment_ch_3: '3. In case of changing the course of study or changing the rank or changing the project that applied, students must apply again and have to pay for new application fee again only. The institute will consider the last application that the application fee has been paid is the time that you would like to take the exam.  Moreover, the previous apply will be void.  Even if the application fee has been paid.',
        regis: 'Apply',
        close: 'Close',
        symbol_explanation: 'Symbol explanation',
        study_plan: 'Plan',
        study_class: 'Class',
    },
    applicantInfo_medical: {
        educational_background: 'Educational Background',
        test_date: 'Exam date',
        standard_academic_test: 'Standard academic test',
        SAT1_subject_test: 'SAT I',
        total: 'Total',
        reading_writing: 'Reading Writing',
        OldSAT_subject_test: 'OLD SAT',
        verbal: 'Verbal',
        writing: 'Writing',
        SAT2_subject_test: 'SAT II',
        biology: 'Biology',
        chemistry: 'Chemistry',
        physics: 'Physics',
        mathematics: 'Mathematics',
        bioMedical_admission_test: 'BioMedical Admission Test (BMAT)',
        section1: 'Section 1',
        section2: 'Section 2',
        section3: 'Section 3',
        SPOT_score: 'SPOT Score',
        english_proficiency_test: 'English proficiency test',
        TOEFL_paper_based: 'TOEFL (Paper based)',
        TOEFL_computer_based: 'TOEFL (Computer based)',
        TOEFL_internet_based: 'TOEFL (Internet based)',
        IELTS_academic_module: 'IELTS (Academic Module)',
        CU_TEP: 'CU-TEP',
        personal_statement: '** Personal statement (In English, less than 1000 words) **',
    },
    applicantInfo_engInter: {
        AP_IB_IGCSE_test_score: 'AP/IB/IGCSE TEST SCORE',
        subject_1_name: 'Subject #1 name',
        subject_1_score: 'Subject #1 score',
        subject_1_test_date: 'Subject #1 test date',
        subject_2_name: 'Subject #2 name',
        subject_2_score: 'Subject #2 score',
        subject_2_test_date: 'Subject #2 test date',
        subject_3_name: 'Subject #3 name',
        subject_3_score: 'Subject #3 score',
        subject_3_test_date: 'Subject #3 test date',
        GED: 'GED',
        GED_RTLA_score: 'Reasoning Through Language Arts',
        GED_MR_score: 'Mathematical Reasoning',
        GED_SCI_score: 'Science',
        GED_SS_score: 'Social Studies',
    },
    toasted: {
        save_successfully: 'Saved Successfully',
        cannot_save: 'Cannot Save',
        create_successfully: 'Create Successfully',
        cannot_create: 'Cannot Create',
        cannot_upload_file: 'Cannot Upload File',
        delete_successfully: 'Delete Successfully',
        cannot_delete: 'Cannot Delete',
        edit_successfully: 'Edit Successfully',
        cannot_edit: 'Cannot Edit',
        mail_sent: 'Your email has been sent',
        mail_sent_to: 'Email has been sent to',
    },
    info_card: {
        name_surename: 'First Name - Surename',
        prename: 'Name Title',
        name_th: 'First Name (Thai)',
        surname_th: 'Surname (Thai)',
        name_th_hint: 'For foreigners who do not have Thai name,  please fill in your  name in English',
        surname_th_hint: 'For foreigners who do not have Thai Surname, please fill in your  Surname in English ',
        name_en: 'Name (English) (UPPERCASE only)',
        surname_en: 'Surname (English) (UPPERCASE only)',

        all_gpa: 'Overall GPA score (GPAX) (Fill in the menu School info)',
        math_credit: 'Mathematics Credit',
        math_gpa: 'Mathematics GPA',
        physics_credit: 'Physics Credit',
        physics_gpa: 'Physics GPA',
        science_credit: 'Science Credit',
        science_gpa: 'Science GPA',
        chemistry_credit: 'Chemistry Credit',
        chemistry_gpa: 'Chemistry GPA',
        bio_credit: 'Biology Credit',
        bio_gpa: 'Biology GPA',
        thai_credit: 'Thai Credit',
        thai_gpa: 'Thai GPA',
        english_credit: 'English Credit',
        english_gpa: 'English GPA',
        science_math_credit: 'Science & Mathematics Credit',
        science_math_gpa: 'Science & Mathematics GPA',
        foreign_credit: 'Foreign language Credit',
        foreign_gpa: 'Foreign language GPA',
        GAT: 'GAT Score',
        PAT: 'PAT Score',
        math_phy_chem_eng_gpa: 'GPA 4 Subjects (Mathematics, Physics, Chemistry, English)',
        math_physics_gpa: 'Mathematics & Physics GPA',

        english_exam: 'English Proficiency Test',
        score: 'Score',
        english_exam_hint: 'The results of the English proficiency test must not exceed 2 years',
        english_exam_result_file: 'English exam result files (TOEFL, IELTS, CU-TEP, TU-GET)',
        academic_exam_result_file: 'Academic exam result files (SAT)',
        essay_file: 'Essay file',

        address_registration: "Permanent Address",
        address_contact: "Temporary Address",
        house_id: "House ID",
        house_number: "House Number",
        village_name: "Village",
        moo: "Village No.",
        soi: "Lane",
        street: "Road",
        province: "Province/State",
        district: "District",
        sub_district: "Sub-District",
        in_thai: "In Thailand",
        foreign_country: "In Other Countries",
        country: "Country",
        other: "Other Ex. GED",

        personal_information: "Personal Information",
        citizen_id: "Citizen ID",
        citizen_id_passport: "Citizen ID / Passport",
        thai: "Thai Student",
        foreigner: "Foreign Student",
        nation_thai: "Thai nationality",
        nation_foreigner: "Other nationalities",
        fill_thai_citizenID: "Fill in Thai citizen ID Number",
        fill_passport_number: "Fill in passport number",
        passport_number: "Passport Number",
        passport_start_date: "Passport issue date",
        passport_end_date: "Passport expiration date",
        birthday: "Birthday",
        mobile: "Mobile Number",
        email: "Email",
        blood_type: "Group of Blood",
        race: "Race",
        nation: "Nationality",
        religion: "Religion",
        father_info: "Father's Information",
        mother_info: "Mother's Information",

        education_background_undergrad: "Education Background (Apply for undergraduate)",
        education_background_grad: "Education Background (Apply for Graduate)",
        school_location: "Location of graduate School",
        university_location: "Location of graduate University",
        university_name: "University Name",
        school_name: "School Name",
        add_school: "If unlisted school name, please send school name and address to email : admission-reg@kmitl.ac.th",
        add_university: "If unlisted school name, please send school name and address to email : grad-reg@kmitl.ac.th)",
        school_type: "School Type",
        education_type: "Education Type",
        education_other: "Education Other",
        education_other_hint: "Fill Education",
        school_student_id: "Student ID in School",
        school_grad_date: "Date of graduation",
        school_grad_date_detail: "*The graduated date must be as same as the graduation document submitted to KMITL.",
        study_status: "Educational Status",
        study_type: "Study type",
        number_of_GPA_term: "Number of GPA terms",
        GPA: "Overall GPA score (GPAX)",
        GPA_hint: "If there is no GPA Score, please enter 0.00./ If your GPA score is greater than 4.00, please enter 4.00.",
        graduated_year: "Year graduated (B.E.)",
        undergraduate_education_history: " Education background (Undergraduate level)",
        university_study_status: "Educational status",
        degree_name: "Degree",
        curriculum_name: "Curriculum",
        graduate_education_history: "Education background (Master's degree)",
        graduate_working_experience: "Work Experience (If any)",
        num_year_working_experience: "Years of experience",
        company_name: "Name of company (1)",
        company_name1: "Name of company (2)",
        position_in_company: "Position",
        since_working: "Since (B.E.)",

        information_for_the_course: "Information for the curriculum to apply for Undergraduate level",
        information_for_the_course_grad: "Information for the curriculum to apply for Graduate level",

        checkbox_1: "Applicants must make sure that they meet requirements according to the university’s announcement and   ",
        checkbox_2: "complete an application completely and honestly",
        checkbox_3: ". If applicants are caught of giving false information, they will be  ",
        checkbox_4: "disqualified ",
        checkbox_5: "and will not get the refund. ",
        announcement: 'Announcement  >> Click',
        here: '<< Here >>',

        history_title: 'History of filling/editing',
        history_type: 'Type',
        history_value: 'Value',
        history_date: 'Date',
        history_no_item: 'No filling/editing history',
    },
    officer_config: {
        addnew: "new addition",
        edit: "Edit",
        delete: "Delete",
        save: "Save",
        confirm: "Confirm",
        cancel: "Cancel",
        //config_year
        config_year: "Specify the open academic year",
        academic_year: "Academic Year",
        semester: "Semester",
        academic_level: "Academic Level",
        admit_date: "Date of Study (of students)",
        start_using_date: "Date of Start by using this academic year",
        //config_faculty_bank_account
        config_faculty_bank_account: "Specify the faculty bank account",
        faculty: "Faculty",
        bank_account_number: "Bank Account Number",
        bank_name_th: "Bank Name (Thai)",
        bank_name_en: "Bank Name (English)",
        bank_info_th: "Bank Information (Thai)",
        bank_info_en: "Bank Information (English)",
        bank_logo: "Bank Logo Image",
        service_charge: "Service Charge",
        //config_round
        config_round: "Specify round of applying",
        year_semester_level: "Academic Year (Level)",
        round_number: "Round Number for Example (1th round,2nd round)",
        round_name_th: "Round Name (Thai)",
        round_name_en: "Round Name (English)",
        round_start_date: "Receiving Start",
        round_end_date: "Receiving End",
        //config_project
        config_project: " Specify the Project",
        round_number_name: "Round-Round Name",
        project_code: "Project Code",
        project_name_th: "Project Name (Thai)",
        project_name_en: "Project Name(English)",
        number_of_ranks: "Number of curiculum selected to apply",
        enabled: "Shown on curriculum search page",
        //config_curriculum
        tcas_program_id: 'TCAS Code',
        config_curriculum: "Specify the curriculum to open",
        project_name: "Project Name",
        curriculum_name: "Curriculum/Program",
        tuition_fee: "Confirm the right (tuition fee)",
        application_fee: "Application fee",
        start_application_date: "Application start date",
        end_application_date: "Application end date",
        applicant_can_upload_file: "Applicant can upload file",
        start_application_pay_date: "Start date of payment",
        end_application_pay_date: "Last date of payment",
        start_confirm_date: "Start date to assertion",
        end_confirm_date: "Last date to assertion",
        start_confirm_pay_date: "Payment start date to assertion",
        end_confirm_pay_date: "Payment last date to assertion",
        attach_PDF_if_any: "Attach PDF file, more information (if any)",
        attach_URL_if_any: "Attach URL file, more information (if any)",
        remark_if_any: "Remark (if any)",
        delete_file: "Delete PDF file",
        branch_if_any: 'Branch (if any)',
        admit_type: 'ประเภทรับเข้า',
        study_plan: 'แผนการศึกษา',
        study_classes: 'ช่วงเวลาเรียน',
        specific_nation: 'กำหนดเฉพาะสัญชาตินักศึกษา (if any)',
        //config_curriculum_constraint
        round: 'round',
        close: 'close',
        constraint: 'constraint on curriculum',
        config_curriculum_constraint: "Specify the constraint on curriculum to open for admission",
        constriant_value: 'Specified criteria',
        copy: 'Copy',
        paste: 'Paste',
        finish: 'Finish',
        number_of_order_allow: "Number of ranks allowed to be selected",
        english_exam_result: 'English exam result file (TOEFL, IELTS, CU-TEP, TU-GET)',
        academic_exam_result: 'Academic exam result file (SAT)',
        essay: 'Essay file',
        minimum_gpa_applicable: "Lowest GPA to apply",
        minimum_number_of_semester: "Minimum GPA term",
        gat_score: "GAT Score",
        pat_score: "PAT Score",
        math_credit: 'Mathematics Credit',
        math_gpa: 'Mathematics GPA',
        physics_credit: 'Physics Credit',
        physics_gpa: 'Physics GPA ',
        science_credit: 'Science Credit',
        science_gpa: 'Science GPA',
        chemistry_credit: 'Chemistry Credit',
        chemistry_gpa: 'Chemistry GPA',
        english_credit: 'English Credit',
        english_gpa: 'English GPA ',
        science_math_credit: 'Science & Mathematics Credit',
        science_math_gpa: 'Science & Mathematics GPA',
        foreign_credit: 'Foreign Language Credit',
        foreign_gpa: 'Foreign Language GPA',
        math_physics_chemistry_english_gpa: 'GPA 4 Subjects (Mathematics, Physics, Chemistry, English)',
        math_physics_gpa: 'Mathematics & Physics GPA',
        application_date: 'Admission Open Date',
        application_pay: 'Payment Date',
        branch: 'Branch',
        curriculum: 'Curriculum',
    },
    questionnaire: {
        title: "Evaluate the satisfaction questionnaire of the admission system.",
        general_information: "The general information of the respondents.",
        birthplace: "Birthplace",
        news_source: "Did you hear the application news from?",
        news_source_specify: "Please specify the news source.",
        device: "Did you use the admissions systems with?",
        internet_used: "Internet used",
        internet_used_specify: "Please specify internet information.",

        level_satisfaction_user: "Level of satisfaction of clients",
        please_fill_in_truth: "*** Please fill in the truth to use as information for improving systems and services. ***",
        header_table1: "Attribute",
        header_table2: "Level",
        header_table2_hint: "(1: Very dissatisfied to 5: Very satisfied)",
        Q1: "1. Process",
        Q1_1: "1.1 (User-Friendly) Easy to use the system",
        Q1_2: "1.2 There is an appropriate admissions procedure.",
        Q1_3: "1.3 There is an appropriate basic recording procedure.",
        Q1_4: "1.4 There is an appropriate public relations for admission.",
        Q1_5: "1.5 How complete do you think this admission system is.",
        Q2: "2. Quality of Content",
        Q2_1: "2.1There is easy to link the information inside the website. ",
        Q2_2: "2.2 There is easy access to the website.",
        Q2_3: "2.3 There is the suitability of the information within the website.",
        Q2_4: "2.4 There is an accuracy and completeness of information.",
        Q3: "3. Design",
        Q3_1: "3.1 There is a beautiful, modern and attractive website.",
        Q3_2: "3.2 They are formatted within the website that are easy to read and use.",
        Q3_3: "3.3 There are font sizes and styles that easy to read.",
        Q3_4: "3.4 There are fast in displaying images, characters and other information.",

        additional_info: "More information",
        additional_1: "Guidelines for program improvement / system development / what to expect.",
        additional_2: "What would you like more? To help you in your admission to further education.",
        additional_3: "More Suggestions / Other Suggestions",
    },
    applicant_info_add: {
        title: "Additional information (For showing in the application form)",
        address: "Address",
        user_detail_1: "Reasons for admission to the KMITL",
        user_detail_2: "English language proficiency skill",
        user_detail_3: "Special Qualifications",
        user_detail_4: "Scholarships that have been received",
        user_detail_5: "Sports competition",
        user_detail_6: "Training / Competition / Academic Olympiads Camp",
        fill_data: "Fill out additional information in the application form such as address, reason for applying, Special Qualifications, etc. << Click >>",
        click_to_print: "Click here to print an application form.",
        please_fill_to_able_print: "Please fill out the information in the button below first. To be able to print an application form.",
    },
    number_of_applicants_report: {
        title: "Reports",
        all_project: "รวมทุกโครงการ",
        curriculum: "สาขา / หลักสูตร",
        not_complete_information: "ยังกรอกข้อมูลไม่ครบ",
        waiting_to_pay_application_fee: "รอจ่ายเงินค่าสมัคร",
        application_fee_paid: "จ่ายเงินค่าสมัครแล้ว",
        summary: "Summary",
    },
    number_of_applicants_by_order_report: {
        title: "Reports by Order + Selective",
        select_order_1: "เลือกเป็นอันดับ 1 (ใบสมัคร)",
        select_order_2: "เลือกเป็นอันดับ 2 (ใบสมัคร)",
        select_order_3: "เลือกเป็นอันดับ 3 (ใบสมัคร)",
        branch: "Branch:",
    },
    applicants_report_list: {
        title: "Reports",
        passed_title: "Reports by Passed",
        year: "Year",
        round: "Round",
        project: "Project",
        faculty: "Faculty",
        curriculum: "Curriculum",
        branch: "Branch",
        type_data: "ประเภทข้อมูล",
        registration_no: "Registration no.",
        name_surname: "Name - Surname",
        applied_timestamp: "วันเวลากดประกาศ",
        citizen_id: "Citizen id",
        email: "Email",
        mobile: "Mobile",
        school: "School",
        notice: "Notice",
        total: "Total",
        person: "person(s)",
        unit: "(The application)",
        file_upload: "File Uploaded",
        address: "Address",
        order_1: "สาขาที่เลือกอันดับ 1",
        order_2: "สาขาที่เลือกอันดับ 2",
        order_3: "สาขาที่เลือกอันดับ 3",
    },
};